import {
  extGet,
  RequestWrapper,
} from './requests';

const baseURL = 'https://servicodados.ibge.gov.br/api/v1/localidades';

const fetchAllStates = (params: {
  orderBy: 'nome' | 'id' | undefined,
  view: 'nivelado' | undefined,
} = {
  orderBy: undefined,
  view: undefined,
}): RequestWrapper => {
  const query: {
    orderBy?: 'nome' | 'id',
    view?: 'nivelado',
  } = {};

  if (params.orderBy) {
    query.orderBy = params.orderBy;
  }

  if (params.view) {
    query.view = params.view;
  }

  return extGet({
    url: `${baseURL}/estados`,
    query: query || null,
  });
};

const fetchStateDetails = (params: {
  identifier: string | number | undefined,
  orderBy: 'nome' | 'id' | undefined,
  view: 'nivelado' | undefined,
} = {
  identifier: undefined,
  orderBy: undefined,
  view: undefined,
}): RequestWrapper => {
  const query: {
    orderBy?: 'nome' | 'id',
    view?: 'nivelado',
  } = {};

  if (!params.identifier) {
    throw new Error('Erro: Informe a sigla ou id do estado.');
  }

  if (params.orderBy) {
    query.orderBy = params.orderBy;
  }

  if (params.view) {
    query.view = params.view;
  }

  return extGet({
    url: `${baseURL}/estados/${params.identifier}`,
    query: query || null,
  });
};

const fetchCitiesByState = (params: {
  identifier: string | number | undefined,
  orderBy: 'nome' | 'id' | undefined,
  view: 'nivelado' | undefined
} = {
  identifier: undefined,
  orderBy: undefined,
  view: undefined,
}): RequestWrapper => {
  const query: {
    orderBy?: 'nome' | 'id',
    view?: 'nivelado'
  } = {};

  if (!params.identifier) {
    throw new Error('Erro: Informe a sigla ou id do estado.');
  }

  if (params.orderBy) {
    query.orderBy = params.orderBy;
  }

  if (params.view) {
    query.view = params.view;
  }

  return extGet({
    url: `${baseURL}/estados/${params.identifier}/municipios`,
    query: query || null,
  });
};

const fetchCityDetails = (params: {
  identifier: string | number | undefined,
  orderBy: 'nome' | 'id' | undefined,
  view: 'nivelado' | undefined
} = {
  identifier: undefined,
  orderBy: undefined,
  view: undefined,
}): RequestWrapper => {
  const query: {
    orderBy?: 'nome' | 'id',
    view?: 'nivelado'
  } = {};

  if (!params.identifier) {
    throw new Error('Erro: Informe a sigla ou id do estado.');
  }

  if (params.orderBy) {
    query.orderBy = params.orderBy;
  }

  if (params.view) {
    query.view = params.view;
  }

  return extGet({
    url: `${baseURL}/municipios/${params.identifier}`,
    query: query || null,
  });
};

export {
  fetchAllStates,
  fetchStateDetails,
  fetchCitiesByState,
  fetchCityDetails,
};
